/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Stitch two edges</h4>

<p>Join two bodies or open faces on edge.</p>

<p>Select the pair of edges to stitch (first the one that will not move), and click the button.</p>

 <div style="padding:56.25% 0 0 0;position:relative;">
        <iframe src="${vimeo('789105375')}"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
        </iframe>
    </div>
    <script src="https://player.vimeo.com/api/player.js"></script>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'>No shortcuts for this operation</li>
</ul>`;

export default function MergeOnEdgeTooltip() {
    return h('div', { innerHTML: body });
}
